import React from "react";
import Shop from "./Shop";

export default function index() {
  return <Shop />;
}
